angular.module('ui.pwdReset', [
    'ui.login.loginShadow'
])

    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('passwordReset', {
            url: '/password/reset?key',
            template: customTemplateResolverProvider.get('pwdReset.html', 'app/ui/login/pwdReset.html'),
            controller: 'PasswordResetController',
            data: {pageTitle: 'OrderManager: Reset password'}
        });
    })

    .controller('PasswordResetController', function PasswordResetController($scope, $state, $localStorage, $stateParams, $timeout, authService, toastr, gettextCatalog, serverLocalization) {
        $scope.isBusy = false;
        $scope.pwdResetSuccess = false;
        $scope.pwdResetKey = $stateParams.key;
        $scope.pwdResetLabel = gettextCatalog.getString("Reset the password for your OrderManager account");
        $scope.passwordValidationRegex = /.*/g;
        $scope.passwordValidationMessage = "";

        //We need to get password validation regex and message to later use with kendo-validator
        authService.getPasswordValidationRegex().then(function (regex) {
            $scope.passwordValidationRegex = regex;
            $scope.passwordValidationMessage = gettextCatalog.getString("PasswordStrength.ValidationMessage");
        });

        //custom validation rule 'password equal'
        $scope.pwdValidatorOptions = {
            rules: {
                pwdequal: function (input) {
                    if (input.is("[name=confirmNewPwd]")) {
                        return input.val() === $scope.newPwd;
                    }
                    return true;
                }
            }
        };

        $scope.doPwdReset = function () {

            if (!$scope.pwdValidator.validate()) {
                return false;
            }

            $scope.pwdResetLabel = gettextCatalog.getString("Resetting password...");
            $scope.isBusy = true;

            authService.doPasswordReset($scope.pwdResetKey, $scope.newPwd)
                .then(
                    function () {
                        $scope.pwdResetLabel = gettextCatalog.getString("Your password has been reset.");
                        $scope.pwdResetSuccess = true;
                        $scope.isBusy = false;
                    },
                    function (resp) {
                        var data = resp.data;
                        var msg;
                        if (data && data.ErrorMessage && _.isString(data.ErrorMessage)) {
                            msg = data.ErrorMessage;
                        } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                            msg = data;
                        } else {
                            msg = gettextCatalog.getString("Password reset failed due to an error");
                        }
                        $scope.pwdResetLabel = gettextCatalog.getString("Password reset failed due to an error");
                        toastr.error(msg, gettextCatalog.getString("Password reset failed"));
                        $scope.isBusy = false;
                        $scope.pwdResetSuccess = false;
                    });

            return false;
        };
    })

;
